import Vue from "vue";
// import axios from "axios"
import VueCookies from "vue-cookies";
Vue.use(VueCookies);

export const state = () => ({
  // state: {
  // },
  salesNo: "",
  branchId: "",
});

export const mutations = {
  UPDATE_SALES_NO: (state, payload) => {
    state.salesNo = payload;
  },
  UPDATE_BRANCH_ID: (state, payload) => {
    state.branchId = payload;
  },
};

export const actions = {
  setSalesNo(context, payload) {
    context.commit("UPDATE_SALES_NO", payload);
  },
};
export const getters = {
  getSalesNo: (state) => {
    return state.salesNo;
  },
  getBranchId: (state) => {
    return state.branchId;
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
